import React from "react";
import CustomReasonInput from "./CustomReasonInput";

export const RESIGNATION_REASONS = [
  "Health issue",
  "Career Changes",
  "Travelling",
  "Abroad",
  "Higher studies",
  "Work related issue",
  "Marriage",
  "Performance issue",
  "Ask to Leave",
  "Better Role & Career progression",
  "Code of Conduct Discipline",
  "Dissatisfaction with manager",
  "Entrepreneur, New business",
  "Family Issues & Commitments",
  "Mis fit for role in Organization",
  "Relocating to Another City",
  "Salary Growth",
];

const OPTIONS = [...RESIGNATION_REASONS]
  .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
  .map(reason => ({ value: reason, label: reason }));

const ResignationReasonInput = props => (
  <CustomReasonInput
    options={OPTIONS}
    placeholder="Select or type your own reason"
    {...props}
  />
);

export default ResignationReasonInput;
